import {POST} from "../util";

const url = {
    checkRetention: "api/common/retention/check",
};
const retentionCheckApi = {
    checkRetention: (params) => {
        return POST(url.checkRetention, params);
    },
};
export {
    retentionCheckApi
};